import { Component, Input, OnInit } from '@angular/core';
import { AssetImage } from 'src/app/model/shared/asset-image';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-expand-image-section',
  templateUrl: './expand-image-section.component.html',
  styleUrls: ['./expand-image-section.component.scss']
})
export class ExpandImageSectionComponent implements OnInit {
  @Input() expandImages: AssetImage[] = [];
  collapsed: boolean[] = [];
  @Input() accordianImage: Section[] = [];
  @Input() isAPIReference: boolean = false;
  isIconTrue: boolean[] = [];
  sectionBorderTrue: boolean[] = [];

  constructor() {}

  ngOnInit(): void {
    this.expandImages?.forEach((i) => {
      this.collapsed.push(false);
    });
    this.accordianImage.forEach((i) => {
      this.collapsed.push(false);
    });
  }

  toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
    this.isIconTrue[index] = !this.isIconTrue[index];
    // this.sectionBorderTrue[index] = !this.sectionBorderTrue[index];
  }

  getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsed';
  }

  getActiveStyle(index: number) {
    return this.collapsed[index] ? 'active' : 'title-hover';
  }

  getArrowIcons(index: number) {
    return this.isIconTrue[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
